import {
  Card,
  Container,
  Table,
  TableContainer
} from '@mui/material';
import DataTableRow from '@src/components/data-table/data-row';
import Scrollbar from '@src/components/scrollbar';
import { TABLE_HEAD_PREVIOUS_DRAW_RESULT } from '@src/utils/mockdata/table-headers';
import { useServices } from '../hooks';
import { useDrawResultContext } from '../provider';
import TableHeader from './table-header';
import TableRowItem from './table-row';
import Toolbar from './toolbar';

function PreviousDraw() {
  return (
    <Body />
  );
}

const Body = () => {
  const { previousDraw, previousLoading } = useServices();
  const { state, handleRequestSort, setViewWinners } = useDrawResultContext();

  return (
    <Container disableGutters sx={{ mt: 7 }}>
      <Toolbar />
      <Card sx={{p: 2}}>
        <Scrollbar>
          <TableContainer>
            <Table>
              <TableHeader
                disableButton
                order={state.order}
                orderBy={state.orderBy}
                onRequestSort={handleRequestSort}
                headLabel={TABLE_HEAD_PREVIOUS_DRAW_RESULT}
              />
              <DataTableRow
                colSpan={7}
                isLoading={previousLoading}
                data={previousDraw?.items ?? []}
                headers={TABLE_HEAD_PREVIOUS_DRAW_RESULT}
                renderItem={({ item, index }: any) => {
                  return <TableRowItem 
                    key={`${index}`} {...item} 
                    onViewWinners={setViewWinners} 
                  />
                }} />
            </Table>
          </TableContainer>
        </Scrollbar>
      </Card>
    </Container>
  );
}

export default PreviousDraw;
